import React, { FC, useEffect, useState } from "react";
import {
  Checkbox,
  DatePicker,
  Input,
  InputNumber,
  InputProps,
  Select,
  Switch,
  TimePicker,
} from "antd";
import { useController } from "react-hook-form";
import Label from "../Label";
import styles from "./TNInputField.module.scss";
import ErrorMessage from "../ErrorMessage";
import ConditionalRender from "../ConditionalRender";
import {
  InputFieldStatus,
  InputfieldTypes,
} from "../../enums/InputFieldAttributesEnums";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import CustomCheckbox from "../CustomCheckbox";
import ELButton from "../TNButton";
import { ButtonType } from "../../enums/ButtonAttributesEnums";
import clsx from "clsx";
import { CheckboxValueType } from "antd/lib/checkbox/Group";
import moment, { Moment } from "moment-timezone";
import { defaultTimerStyle, inputConstantProps } from "./constants";
import { overallConstants } from "../../Components/BidToolConfigurationView/constants";
import NumberFormat from "react-number-format";
import { DateFormat } from "../../enums/dateTimeFormat";
import AlertIcon from "../../assets/images/alert-red.svg";
interface optionsProps {
  value: string | number | boolean;
  label: string | React.ReactElement;
}
interface InputFieldProps {
  name: string;
  placeholder?: string;
  type: InputfieldTypes;
  disabled?: boolean;
  disabledOptions?: number[];
  addonBefore?: React.ReactNode;
  addonAfter?: React.ReactNode;
  addonLater?: React.ReactNode;
  addonPrev?: React.ReactNode;
  suffix?: React.ReactNode;
  tabsOptions?: optionsProps[];
  className?: string;
  dropdownClassName?: string;
  value?: string | number | boolean;
  label?: string;
  requiredField?: boolean;
  fieldAlert?: boolean;
  customError?: string;
  options?: optionsProps[];
  textAreaRows?: number;
  values?: CheckboxValueType[];
  onChange?: (val: boolean | string | CheckboxValueType[] | string[]) => void;
  optionFilterProp?: string;
  showCount?: boolean;
  maxLength?: number;
  handleNumberChange?: (val: number) => void;
  onSelect?: (selectedValue?: string) => void;
  resetCheckbox?: () => void;
  bordered?: boolean;
  preventDefaultStyle?: boolean;
  infoDetails?: React.ReactNode;
  dropdownMatchSelectWidth?: boolean;
  noLabel?: boolean;
  showSearch?: boolean;
  allowClear?: boolean;
  customSelect?: boolean;
  onBlur?: (event?: React.FocusEvent<HTMLInputElement>) => void;
  changeHandler?: (event?: React.ChangeEvent<HTMLInputElement>) => void;
  onClear?: () => void;
  small?: boolean;
  prefix?: string;
  customNumberInputError?: boolean;
  customTextInputError?: boolean;
  customSelectInputError?: boolean;
  customSmallErrorText?: boolean;
  customLarge?: boolean;
  onKeyDownText?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  formatterFn?: (value: string) => string;
  formattedNumberType?: boolean;
  disabledDates?: (current: moment.Moment) => boolean;
  defaultDate?: Moment;
  allowDateClear?: boolean;
  disabledTimes?: any;
  selectLoading?: boolean;
  onRangePickerChange?: (dates: Moment[] | null) => void;
  dropdownSelectRender?: React.ReactNode;
  handleOnSelect?: (selectedCustomer: string) => void;
  selectFieldOptions?: DropdownOptionsProps[] | CheckboxOptionType[];
  onChangeSelectHandler?: (
    fieldName: string,
  ) => (event: React.ChangeEventHandler<HTMLInputElement>) => void;
  datepickerSize?: string;
  selectedDate?: Moment;
  minValue?: number;
  maxValue?: number;
  textAreaValue?: string;
  setSearch?: () => void;
  numberPrecision?: number;
  noResize?: boolean;
  autoSize?: boolean | { minRows: number; maxRows: number };
  maxTextLength?: number;
  valueState?: string;
  defaultSwitch?: boolean;
  onFocus?: () => void;
  large?: boolean;
  fixedDecimalScale?: boolean;
  searchValue?: string;
  allowTyping?: boolean;
  onDateChange?: (date: moment.Moment | null, dateString: string) => void;
  customNote?: string;
}
const InputField: FC<InputFieldProps & InputProps> = (props) => {
  const {
    name,
    placeholder,
    disabled,
    label,
    requiredField,
    fieldAlert,
    type,
    options,
    textAreaRows,
    onChange,
    optionFilterProp = "value",
    onSelect,
    showCount,
    maxLength,
    noResize = false,
    className,
    dropdownClassName,
    bordered,
    value: initialValue,
    resetCheckbox,
    infoDetails,
    preventDefaultStyle,
    values,
    noLabel,
    showSearch,
    handleNumberChange,
    tabsOptions,
    allowClear,
    onBlur,
    changeHandler,
    customSelect,
    addonAfter,
    addonBefore,
    addonPrev,
    addonLater,
    suffix,
    small,
    prefix,
    customNumberInputError,
    customTextInputError,
    customSelectInputError,
    customSmallErrorText = false,
    onKeyDownText,
    customLarge = false,
    formatterFn,
    formattedNumberType,
    disabledDates,
    defaultDate,
    allowDateClear = false,
    disabledTimes,
    onRangePickerChange,
    dropdownSelectRender,
    handleOnSelect,
    onChangeSelectHandler,
    selectFieldOptions,
    datepickerSize,
    selectedDate,
    minValue,
    maxValue,
    textAreaValue,
    setSearch,
    selectLoading,
    numberPrecision,
    autoSize = false,
    maxTextLength,
    valueState,
    defaultSwitch,
    onFocus,
    large,
    fixedDecimalScale = false,
    searchValue,
    onDateChange,
    allowTyping = false,
    customNote,
    ...rest
  } = props;
  const {
    field,
    fieldState: { error: validationError },
  } = useController({
    name,
    rules: requiredField
      ? { required: overallConstants.MATERIAL_PRICE }
      : undefined,
  });
  const { Password, TextArea } = Input;
  const { RangePicker } = DatePicker;
  const { ERROR } = InputFieldStatus;
  const [value, setValue] = useState<string | number | boolean | undefined>(
    initialValue,
  );
  const [selectOpen, setSelectOpen] = useState<boolean>(false);
  const handleToggle = (optionValue: string) => {
    const newValue = field.value?.includes(optionValue)
      ? field.value.filter((val: string) => val !== optionValue)
      : [...(field.value || []), optionValue];
    field.onChange(newValue);
  };
  const handleSingleOptionToggle = (optionValue: string) => {
    const newValue = field.value === optionValue ? "" : optionValue;
    field.onChange(newValue);
  };
  const getMultipleSelectValues = (
    values: CheckboxValueType[],
    options: optionsProps[],
  ) => {
    if (!values?.length) return undefined;

    const findLabel = (value: CheckboxValueType) => {
      const option = options.find((opt) => opt.value === value);
      return option ? option.label : value;
    };

    if (values.length === 1 && values[0] === "Select") {
      return findLabel(values[0]);
    }

    if (values.length > 1) {
      if (!values.includes("Select")) {
        const firstValueLabel = findLabel(values[0]);
        const additionalCount = values.length - 1;
        return typeof firstValueLabel === "string" && firstValueLabel.length > 9
          ? `${firstValueLabel.substring(0, 9)}... +${additionalCount}`
          : `${firstValueLabel}... +${additionalCount}`;
      } else {
        const filteredOptions = values.filter((option) => option !== "Select");
        if (filteredOptions.length === 1) {
          const firstFilteredLabel = findLabel(filteredOptions[0]);
          return typeof firstFilteredLabel === "string" &&
            firstFilteredLabel.length > 9
            ? `${firstFilteredLabel.substring(0, 9)}...`
            : firstFilteredLabel;
        }
        const firstFilteredLabel = findLabel(filteredOptions[0]);
        const additionalCount = filteredOptions.length - 1;
        return typeof firstFilteredLabel === "string" &&
          firstFilteredLabel.length > 9
          ? `${firstFilteredLabel.substring(0, 9)}... +${additionalCount}`
          : `${firstFilteredLabel}... +${additionalCount}`;
      }
    }

    const singleValueLabel = findLabel(values[0]);
    return typeof singleValueLabel === "string" && singleValueLabel.length > 9
      ? `${singleValueLabel.substring(0, 9)}...`
      : singleValueLabel;
  };
  const handleSearchableChange = (selectedValues: CheckboxValueType[]) => {
    const searchableValueSet = new Set(options?.map((option) => option.value));
    const hiddenSelectedValues = (values ?? []).filter(
      (value) => !searchableValueSet.has(value),
    );

    onChange?.([...hiddenSelectedValues, ...selectedValues]);
  };

  const inputContainer = clsx({
    [styles.inputContainer]:
      type !== InputfieldTypes.CHECKBOX && !preventDefaultStyle,
  });
  const fieldContainer = clsx({
    [styles.fieldContainer]:
      type !== InputfieldTypes.CHECKBOX && !preventDefaultStyle,
  });
  const defaultTorontoTime = moment.tz.setDefault("America/Toronto");
  const handleChange = (e: CheckboxChangeEvent) => {
    const newValue = e.target.checked;
    setValue(newValue);
    field.onChange(newValue);
    onChange?.(newValue);
  };
  // const handleClear = () => {
  //   setValue(undefined);
  //   field.onChange(undefined); // Reset value in react-hook-form
  // };

  const handleSelectChange = (value = null) => {
    field.onChange(value);
    if (changeHandler) {
      changeHandler(value);
    }
  };

  const handleSelectClear = () => {
    field.onChange(null);
    document.activeElement?.blur();
  };

  const handleSwitchChange = (val) => {
    field.onChange(val);
    if (onChange) {
      onChange(val);
    }
  };

  const handleDatePickerChange = (
    date: moment.Moment | null,
    dateString: string,
  ) => {
    field.onChange(date, dateString);
    if (onDateChange) {
      onDateChange(date, dateString);
    }
  };

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);
  return (
    <>
      <ConditionalRender
        visible={
          type === InputfieldTypes.SELECT &&
          customSelect &&
          !customSelectInputError &&
          !customLarge
        }
      >
        <div className={styles.smallInputContainer}>
          <Select
            {...field}
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            bordered={bordered ?? true}
            showSearch={showSearch}
            autoClearSearchValue
            placeholder={placeholder}
            disabled={disabled}
            size="small"
            options={options}
            onSelect={onSelect}
            allowClear={allowClear ?? false}
            status={validationError ? ERROR : undefined}
            optionFilterProp={optionFilterProp}
            // className={styles.SmallSelectComponent}
            style={{
              maxWidth: "88px",
              maxHeight: "30px",
              borderRadius: "8px",
            }}
            onChange={(value = null) => {
              field.onChange(value);
              if (changeHandler) {
                changeHandler(value);
              }
            }}
            onClear={() => {
              field.onChange(null); // Clears the value in the form
              document.activeElement?.blur(); // Remove focus from the field
            }}
          />
        </div>
      </ConditionalRender>

      <ConditionalRender visible={type !== InputfieldTypes.MARGINLESS_TEXT}>
        <div className={inputContainer}>
          {type !== InputfieldTypes.CHECKBOX && !noLabel && (
            <ConditionalRender
              visible={infoDetails}
              fallback={
                <Label
                  required={requiredField}
                  alert={fieldAlert}
                  label={label}
                  name={name}
                />
              }
            >
              <Label
                required={requiredField}
                alert={fieldAlert}
                label={label}
                name={name}
              />{" "}
              &nbsp;
              {/* <Popover
            content={infoDetails}
            placement={PlacementPositions.TOP_LEFT}
          >
            <img
              src={infoIcon}
              className={styles.infoIconWrapper}
              alt={inputConstantProps.INFO}
            />
          </Popover> */}
            </ConditionalRender>
          )}
          <ConditionalRender visible={type === InputfieldTypes.TEXT && small}>
            <div className={styles.smallFieldContainer}>
              <Input
                {...field}
                bordered={bordered}
                placeholder={placeholder}
                size="small"
                disabled={disabled}
                status={validationError ? ERROR : undefined}
                onBlur={onBlur}
                addonAfter={addonAfter}
                addonBefore={addonBefore}
                prefix={prefix ? `${prefix}` : ""}
                suffix={suffix ? `${suffix}` : ""}
                style={{ borderRadius: "4px", height: "28px" }}
                {...rest}
              />
              <ConditionalRender visible={validationError}>
                <div
                  className={
                    customSmallErrorText
                      ? styles.smallCustomErrorMessage
                      : styles.smallErrorMessage
                  }
                >
                  <ErrorMessage message={validationError?.message} />
                </div>
              </ConditionalRender>
            </div>
          </ConditionalRender>
          <div className={fieldContainer}>
            <ConditionalRender
              visible={
                type === InputfieldTypes.SELECT &&
                !customSelect &&
                !customSelectInputError &&
                customLarge
              }
            >
              <Select
                {...field}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                bordered={bordered ?? true}
                showSearch={showSearch}
                autoClearSearchValue
                placeholder={placeholder}
                disabled={disabled}
                options={options}
                onSelect={onSelect}
                allowClear={allowClear ?? false}
                status={validationError ? ERROR : undefined}
                optionFilterProp={optionFilterProp}
                // className={styles.SmallSelectComponent}
                style={{
                  maxHeight: "30px",
                  borderRadius: "8px",
                }}
                onChange={(value = null) => {
                  field.onChange(value);
                  if (changeHandler) {
                    changeHandler(value);
                  }
                }}
                onClear={() => {
                  field.onChange(null); // Clears the value in the form
                  document.activeElement?.blur(); // Remove focus from the field
                }}
              />
            </ConditionalRender>
            <ConditionalRender visible={type === InputfieldTypes.TIME_PICKER}>
              <div className={styles.timePickerWrapper}>
                <TimePicker
                  {...field}
                  use12Hours
                  className={className}
                  inputReadOnly={!allowTyping} // Change this line
                  defaultValue={defaultTorontoTime}
                  format={inputConstantProps.TIME_FORMAT}
                  placeholder={placeholder}
                  disabled={disabled}
                  disabledTime={disabledTimes}
                  {...(selectedDate
                    ? {
                        onChange: (time) => {
                          const now = moment();
                          const selectedMoment = time;

                          if (
                            selectedMoment &&
                            selectedDate?.isSame(now, "day") &&
                            selectedMoment.isAfter(now)
                          ) {
                            return;
                          }

                          const formattedTime = selectedMoment
                            ? selectedMoment.format(
                                inputConstantProps.TIME_FORMAT,
                              )
                            : "";

                          field.onChange(formattedTime);
                        },
                      }
                    : {
                        onChange: (time) => {
                          const formattedTime = time
                            ? time?.format(inputConstantProps.TIME_FORMAT)
                            : "";
                          field.onChange(formattedTime);
                        },
                      })}
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  style={defaultTimerStyle}
                  value={
                    field.value &&
                    moment(
                      field.value,
                      inputConstantProps.TIME_FORMAT,
                      true,
                    ).isValid()
                      ? moment(field.value, inputConstantProps.TIME_FORMAT)
                      : null
                  }
                  status={validationError ? ERROR : undefined}
                  placement={"topLeft"}
                />
                <ConditionalRender visible={!!customNote}>
                  <span className={styles.customFieldNote}>{customNote}</span>
                </ConditionalRender>
              </div>
            </ConditionalRender>
            <ConditionalRender
              visible={
                type === InputfieldTypes.TEXT && !small && !formattedNumberType
              }
            >
              <Input
                {...field}
                bordered={bordered}
                placeholder={placeholder}
                disabled={disabled}
                status={validationError ? ERROR : undefined}
                onBlur={onBlur}
                addonAfter={addonAfter}
                addonBefore={addonBefore}
                allowClear={allowClear}
                maxLength={maxTextLength}
                prefix={prefix}
                suffix={suffix}
                /*May need it in future*/
                // value={value}
                // onKeyDown={(e) => {
                //   onKeyDownText?.(e);
                //   rest.onKeyDown?.(e);
                // }}
                {...rest}
              />
            </ConditionalRender>
            <ConditionalRender visible={type === InputfieldTypes.ONCHANGE_TEXT}>
              <Input
                {...field}
                bordered={bordered}
                placeholder={placeholder}
                disabled={disabled}
                status={validationError ? ERROR : undefined}
                onBlur={onBlur}
                addonAfter={addonAfter}
                addonBefore={addonBefore}
                allowClear={allowClear}
                maxLength={maxTextLength}
                onChange={onChange}
                {...rest}
              />
            </ConditionalRender>
            <ConditionalRender
              visible={type === InputfieldTypes.CONTROLLED_TEXT}
            >
              <Input
                {...field}
                bordered={bordered}
                placeholder={placeholder}
                disabled={disabled}
                status={validationError ? ERROR : undefined}
                onBlur={onBlur}
                addonAfter={addonAfter}
                addonBefore={addonBefore}
                allowClear={allowClear}
                maxLength={maxTextLength}
                {...rest}
              />
            </ConditionalRender>

            <ConditionalRender
              visible={
                type === InputfieldTypes.NUMBER && !customNumberInputError
              }
            >
              <InputNumber
                {...field}
                bordered={bordered}
                placeholder={placeholder}
                disabled={disabled}
                value={typeof value === "number" ? value : undefined}
                status={validationError ? ERROR : undefined}
                prefix={prefix ? `${prefix}` : ""}
                {...(!!formatterFn
                  ? { formatter: (val) => formatterFn(val) }
                  : {})}
                onBlur={onBlur}
                onChange={handleNumberChange}
                addonAfter={addonLater}
                addonBefore={addonPrev}
                min={minValue}
                max={maxValue}
                precision={numberPrecision}
              />
            </ConditionalRender>
            <ConditionalRender
              visible={
                type === InputfieldTypes.NUMBER && customNumberInputError
              }
            >
              <div className={styles.numberFieldContainer}>
                <InputNumber
                  {...field}
                  bordered={bordered}
                  placeholder={placeholder}
                  disabled={disabled}
                  value={typeof value === "number" ? value : undefined}
                  status={validationError ? ERROR : undefined}
                  prefix={prefix ? `${prefix}` : ""}
                  {...(!!formatterFn
                    ? { formatter: (val) => formatterFn(val) }
                    : {})}
                  onBlur={onBlur}
                  onChange={handleNumberChange}
                  addonAfter={addonLater}
                  addonBefore={addonPrev}
                  precision={numberPrecision}
                />
                <ConditionalRender visible={validationError}>
                  <div className={styles.customNumberErrorMessage}>
                    <ErrorMessage message={validationError?.message} />
                  </div>
                </ConditionalRender>
              </div>
            </ConditionalRender>

            <ConditionalRender visible={type === InputfieldTypes.SWITCH}>
              <Switch
                {...field}
                onChange={handleSwitchChange}
                checked={value as boolean}
                disabled={disabled}
                defaultChecked={defaultSwitch as boolean}
              />
            </ConditionalRender>
            <ConditionalRender visible={type === InputfieldTypes.PASSWORD}>
              <Password
                {...field}
                placeholder={placeholder}
                disabled={disabled}
                status={validationError ? ERROR : undefined}
              />
            </ConditionalRender>
            <ConditionalRender visible={type === InputfieldTypes.TAG_SELECT}>
              <Select
                {...field}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                showSearch={showSearch}
                bordered={bordered ?? true}
                autoClearSearchValue
                placeholder={placeholder}
                disabled={disabled}
                options={options}
                onSelect={onSelect}
                mode="tags"
                maxTagCount={1}
                maxTagTextLength={28}
                allowClear={allowClear ?? false}
                status={validationError ? ERROR : undefined}
                optionFilterProp={optionFilterProp}
                {...(onChange
                  ? {
                      onChange: onChange,
                    }
                  : {})}
                className={styles.GeneralSelectComponent}
                onClear={handleSelectClear}
                onChange={onChange}
                value={value}
              />
            </ConditionalRender>
            <ConditionalRender
              visible={
                type === InputfieldTypes.SELECT &&
                !customSelect &&
                !customSelectInputError &&
                !customLarge
              }
            >
              <Select
                {...field}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                showSearch={showSearch}
                bordered={bordered ?? true}
                autoClearSearchValue
                placeholder={placeholder}
                disabled={disabled}
                loading={selectLoading}
                options={options}
                onSelect={onSelect}
                // size='large'
                allowClear={allowClear ?? false}
                status={validationError ? ERROR : undefined}
                optionFilterProp={optionFilterProp}
                {...(onChange
                  ? {
                      onChange: onChange,
                    }
                  : {})}
                className={styles.GeneralSelectComponent}
                onClear={handleSelectClear}
                onChange={handleSelectChange}
                filterOption={(input, option) =>
                  String(option?.label ?? "")
                    ?.toLowerCase()
                    ?.includes(input?.toLowerCase())
                }
              />
            </ConditionalRender>
            <ConditionalRender
              visible={
                type === InputfieldTypes.SELECT &&
                !customSelect &&
                customSelectInputError &&
                !customLarge
              }
            >
              <div className={styles.customSelectContainer}>
                <Select
                  {...field}
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  bordered={bordered ?? true}
                  showSearch={showSearch}
                  autoClearSearchValue
                  placeholder={placeholder}
                  disabled={disabled}
                  options={options}
                  onSelect={onSelect}
                  // size='large'
                  allowClear={allowClear ?? false}
                  status={validationError ? ERROR : undefined}
                  optionFilterProp={optionFilterProp}
                  className={styles.GeneralSelectComponent}
                />
                <ConditionalRender visible={validationError}>
                  <div className={styles.customSelectErrorMessage}>
                    <ErrorMessage message={validationError?.message} />
                  </div>
                </ConditionalRender>
              </div>
            </ConditionalRender>
            <ConditionalRender
              visible={type === InputfieldTypes.MULTIPLE_SELECT}
            >
              <Select
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                popupClassName={styles.multipleSelectContainer}
                placeholder={placeholder}
                bordered={bordered ?? false}
                value={getMultipleSelectValues(values ?? [], options ?? [])}
                className={className}
                dropdownRender={() => (
                  <div className={styles.checkboxGroupContainer}>
                    <Checkbox.Group
                      disabled={disabled}
                      options={options?.map((option) => ({
                        ...option,
                        disabled:
                          props.disabledOptions?.includes(+option.value) ??
                          false,
                      }))}
                      onChange={onChange}
                      value={values}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "0.5rem",
                        marginRight: "0.5rem",
                      }}
                      className={styles.serviceList}
                    />
                    <div className={styles.clearButtonContainer}>
                      <ELButton
                        type={ButtonType.TEXT}
                        onClick={resetCheckbox}
                        className={styles.clearButton}
                        text={<p className={styles.clearButtonFont}>Clear</p>}
                      />
                    </div>
                  </div>
                )}
                dropdownMatchSelectWidth={false}
              />
            </ConditionalRender>
            <ConditionalRender
              visible={type === InputfieldTypes.MULTIPLE_SELECT_SEARCH}
            >
              <Select
                showSearch
                // getPopupContainer={(triggerNode) => triggerNode.parentNode}
                popupClassName={styles.multipleSelectContainer}
                placeholder={placeholder}
                bordered={bordered ?? false}
                value={getMultipleSelectValues(values ?? [], options ?? [])}
                className={className}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                onSearch={(val) => {
                  if (val?.replace(/^\s/, "")?.length <= 20) {
                    setSearch(val?.trimStart());
                  }
                }}
                onBlur={onBlur}
                onFocus={onFocus}
                searchValue={searchValue}
                dropdownClassName={dropdownClassName}
                dropdownRender={() => {
                  return (
                    <div className={styles.checkboxGroupContainer}>
                      <Checkbox.Group
                        disabled={disabled}
                        options={options?.map((option) => ({
                          ...option,
                          disabled:
                            props.disabledOptions?.includes(+option.value) ??
                            false,
                        }))}
                        onChange={handleSearchableChange}
                        value={values}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "0.5rem",
                          marginRight: "0.5rem",
                        }}
                        className={styles.serviceList}
                      />
                      <div className={styles.clearButtonContainer}>
                        <ELButton
                          type={ButtonType.TEXT}
                          onClick={resetCheckbox}
                          className={styles.clearButton}
                          text={<p className={styles.clearButtonFont}>Clear</p>}
                        />
                      </div>
                    </div>
                  );
                }}
                dropdownMatchSelectWidth={false}
              />
            </ConditionalRender>
            <ConditionalRender
              visible={type === InputfieldTypes.SELECT_CUSTOM_FIELD}
            >
              <Select
                {...field}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (typeof option?.label === "string"
                    ? (option?.label ?? "")
                    : typeof option?.children === "string"
                      ? (option?.children ?? "")
                      : ""
                  )
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                name={name}
                customSelect={false}
                placeholder={placeholder}
                type={type}
                allowClear={allowClear}
                options={options}
                open={selectOpen}
                onDropdownVisibleChange={setSelectOpen}
                onSelect={onSelect}
                onChange={onChange}
                status={validationError ? ERROR : undefined}
                dropdownRender={(menu) => (
                  <>
                    <div onClick={() => setSelectOpen(false)}>
                      {dropdownSelectRender}
                    </div>
                    {menu}
                  </>
                )}
              />
            </ConditionalRender>
            <ConditionalRender visible={type === InputfieldTypes.CHECKBOX}>
              <Checkbox
                {...field}
                disabled={disabled}
                checked={value as boolean}
                onChange={handleChange}
              >
                <p className={styles.checkBoxLabel}>
                  {label}
                  {fieldAlert ? (
                    <img className={styles.alert} src={AlertIcon} />
                  ) : null}
                </p>
              </Checkbox>
            </ConditionalRender>
            <ConditionalRender visible={type === InputfieldTypes.TEXT_AREA}>
              <TextArea
                className={clsx({ [styles.noResize]: noResize })}
                {...field}
                maxLength={maxLength}
                showCount={showCount}
                placeholder={placeholder}
                {...(textAreaValue
                  ? {
                      value: textAreaValue,
                    }
                  : {})}
                disabled={disabled}
                rows={textAreaRows ?? 4}
                status={validationError ? ERROR : undefined}
                bordered={bordered ?? true}
                autoSize={autoSize}
              />
            </ConditionalRender>
            <ConditionalRender visible={type === InputfieldTypes.OPTIONS_TABS}>
              <div className={styles.optionTabsContainer}>
                {tabsOptions?.map((option, index) => (
                  <CustomCheckbox
                    key={index}
                    label={String(option.label)}
                    checked={field.value?.includes(option.value)}
                    onChange={() => handleToggle(String(option?.value))}
                    disabled={disabled}
                  />
                ))}
              </div>
            </ConditionalRender>
            <ConditionalRender
              visible={type === InputfieldTypes.SINGLE_OPTION_TAB}
            >
              <div className={styles.optionTabsContainer}>
                {tabsOptions?.map((option, index) => (
                  <CustomCheckbox
                    key={index}
                    label={String(option.label)}
                    checked={field.value?.includes(option.value)}
                    onChange={() =>
                      handleSingleOptionToggle(String(option?.value))
                    }
                    disabled={disabled}
                  />
                ))}
              </div>
            </ConditionalRender>
            {/* <ConditionalRender visible={type === InputfieldTypes.DATE_PICKER}>
              <DatePicker
                {...field}
                bordered={bordered}
                placeholder={placeholder}
                format={DateFormat.MM_DD_YYYY_SLASHED}
                disabled={disabled}
                status={validationError ? ERROR : undefined}
                onBlur={onBlur}
                addonAfter={addonAfter}
                addonBefore={addonBefore}
                size={datepickerSize}
                defaultPickerValue={
                  field.value
                    ? moment(field.value, DateFormat.MM_DD_YYYY_SLASHED)
                    : null
                }
                value={
                  moment(
                    field.value,
                    DateFormat.MM_DD_YYYY_SLASHED,
                    true
                  ).isValid()
                    ? moment(field.value, DateFormat.MM_DD_YYYY_SLASHED)
                    : defaultDate ?? null
                }
                onChange={handleDatePickerChange}
                disabledDate={disabledDates}
                allowClear={allowDateClear}
                inputReadOnly={true}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
              />
            </ConditionalRender> */}
            <ConditionalRender visible={type === InputfieldTypes.DATE_PICKER}>
              <DatePicker
                {...field}
                bordered={bordered}
                placeholder={placeholder}
                format={DateFormat.MM_DD_YYYY_SLASHED}
                disabled={disabled}
                status={validationError ? ERROR : undefined}
                onBlur={onBlur}
                addonAfter={addonAfter}
                addonBefore={addonBefore}
                size={datepickerSize}
                defaultPickerValue={
                  field.value
                    ? moment(field.value, DateFormat.MM_DD_YYYY_SLASHED)
                    : null
                }
                value={
                  moment(
                    field.value,
                    DateFormat.MM_DD_YYYY_SLASHED,
                    true,
                  ).isValid()
                    ? moment(field.value, DateFormat.MM_DD_YYYY_SLASHED)
                    : (defaultDate ?? null)
                }
                onChange={handleDatePickerChange}
                disabledDate={disabledDates}
                allowClear={allowDateClear}
                inputReadOnly={!allowTyping} // Add this line
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
              />
            </ConditionalRender>
            <ConditionalRender
              visible={
                validationError &&
                !small &&
                !customNumberInputError &&
                !customSelectInputError &&
                !formattedNumberType
              }
            >
              <ErrorMessage message={validationError?.message} />
            </ConditionalRender>
            <ConditionalRender
              visible={
                type === InputfieldTypes.TEXT && formattedNumberType && large
              }
            >
              <NumberFormat
                {...field}
                bordered={bordered}
                thousandSeparator
                decimalScale={2}
                fixedDecimalScale={fixedDecimalScale}
                placeholder={placeholder}
                size="small"
                disabled={disabled}
                status={validationError ? ERROR : undefined}
                onBlur={onBlur}
                addonAfter={addonAfter}
                addonBefore={addonBefore}
                prefix={prefix ? `${prefix}` : ""}
                suffix={suffix ? `${suffix}` : ""}
                {...rest}
                customInput={Input}
              />
              <ConditionalRender visible={validationError}>
                <div
                  className={
                    customSmallErrorText
                      ? styles.smallCustomErrorMessage
                      : styles.smallErrorMessage
                  }
                >
                  <ErrorMessage message={validationError?.message} />
                </div>
              </ConditionalRender>
            </ConditionalRender>
          </div>
          <ConditionalRender
            visible={
              type === InputfieldTypes.TEXT && formattedNumberType && !large
            }
          >
            <div className={styles.smallFormattedFieldContainer}>
              <NumberFormat
                {...field}
                bordered={bordered}
                thousandSeparator
                decimalScale={2}
                fixedDecimalScale={true}
                placeholder={placeholder}
                size="small"
                disabled={disabled}
                status={validationError ? ERROR : undefined}
                onBlur={onBlur}
                onFocus={onFocus}
                addonAfter={addonAfter}
                addonBefore={addonBefore}
                prefix={prefix ? `${prefix}` : ""}
                suffix={suffix ? `${suffix}` : ""}
                style={{ borderRadius: "4px", height: "28px" }}
                {...rest}
                customInput={Input}
              />
              <ConditionalRender visible={validationError}>
                <div
                  className={
                    customSmallErrorText
                      ? styles.smallCustomErrorMessage
                      : styles.smallErrorMessage
                  }
                >
                  <ErrorMessage message={validationError?.message} />
                </div>
              </ConditionalRender>
            </div>
          </ConditionalRender>
          {/* <ConditionalRender visible={type === InputfieldTypes.RANGE_PICKER}>
            <RangePicker
              {...field}
              placeholder={placeholder}
              size={"large"}
              disabledDate={disabledDates}
              format={DateFormat.MM_DD_YYYY_SLASHED}
              suffixIcon={suffix}
              className={className}
              disabled={disabled}
              value={
                Array.isArray(field.value) &&
                field.value.length === 2 &&
                moment(
                  field.value[0],
                  DateFormat.MM_DD_YYYY_SLASHED,
                  true
                ).isValid() &&
                moment(
                  field.value[1],
                  DateFormat.MM_DD_YYYY_SLASHED,
                  true
                ).isValid()
                  ? [
                      moment(field.value[0], DateFormat.MM_DD_YYYY_SLASHED),
                      moment(field.value[1], DateFormat.MM_DD_YYYY_SLASHED),
                    ]
                  : null
              }
              {...(onRangePickerChange
                ? {
                    onChange: onRangePickerChange,
                  }
                : {})}
              allowClear={allowDateClear}
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
            />
          </ConditionalRender> */}
          <ConditionalRender visible={type === InputfieldTypes.RANGE_PICKER}>
            <RangePicker
              {...field}
              placeholder={placeholder}
              size={"large"}
              disabledDate={disabledDates}
              format={DateFormat.MM_DD_YYYY_SLASHED}
              suffixIcon={suffix}
              className={className}
              disabled={disabled}
              inputReadOnly={!allowTyping} // Add this line
              value={
                Array.isArray(field.value) &&
                field.value.length === 2 &&
                moment(
                  field.value[0],
                  DateFormat.MM_DD_YYYY_SLASHED,
                  true,
                ).isValid() &&
                moment(
                  field.value[1],
                  DateFormat.MM_DD_YYYY_SLASHED,
                  true,
                ).isValid()
                  ? [
                      moment(field.value[0], DateFormat.MM_DD_YYYY_SLASHED),
                      moment(field.value[1], DateFormat.MM_DD_YYYY_SLASHED),
                    ]
                  : null
              }
              {...(onRangePickerChange
                ? {
                    onChange: onRangePickerChange,
                  }
                : {})}
              allowClear={allowDateClear}
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
            />
          </ConditionalRender>
        </div>
      </ConditionalRender>
      <ConditionalRender visible={type === InputfieldTypes.MARGINLESS_TEXT}>
        <Input
          {...field}
          bordered={bordered}
          placeholder={placeholder}
          disabled={disabled}
          status={validationError ? ERROR : undefined}
          onBlur={onBlur}
          addonAfter={addonAfter}
          addonBefore={addonBefore}
          onChange={onChange}
          maxLength={maxLength}
          {...rest}
        />
      </ConditionalRender>
    </>
  );
};

export default InputField;
